<template lang="html">
  <!-- nothing to show here -->
</template>

<script>
export default {
  name: 'process-vacancy-preferences-special',

  props: {
    vacancy: {
      type: Object,
      default: null
    }
  }
}
</script>
